import React from 'react';
import MapBox from "../MapBox/MapBox"


export default function LayoutMap() {
    return (
        <MapBox />
    )
}